import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { motion } from 'framer-motion';
import { FiCheckCircle, FiXCircle } from 'react-icons/fi';
import api from '../utils/api';

export default function VerifyCertificate() {
  const { serial } = useParams();
  const [cert, setCert] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    api.get(`/certificates/verify/${serial}`).then(r => setCert(r.data)).catch(() => setError(true)).finally(() => setLoading(false));
  }, [serial]);

  return (
    <div style={{ paddingTop: 74, minHeight: '100vh', background: 'var(--off-white)' }}>
      <div className="container" style={{ maxWidth: 580, padding: '5rem 2rem' }}>
        {loading ? <div style={{ textAlign:'center', color:'var(--gray-400)' }}>Verifying...</div> : error ? (
          <motion.div initial={{ opacity:0,y:20 }} animate={{ opacity:1,y:0 }} style={{ background:'white', borderRadius:'24px', padding:'3rem', textAlign:'center', boxShadow:'var(--shadow)' }}>
            <FiXCircle style={{ fontSize:'3.5rem', color:'#EF4444', marginBottom:'1rem' }} />
            <h2 style={{ fontFamily:'Fraunces,serif', color:'var(--navy)', marginBottom:'0.5rem' }}>Certificate Not Found</h2>
            <p style={{ color:'var(--gray-500)' }}>No valid certificate found for serial <strong>{serial}</strong>.</p>
          </motion.div>
        ) : (
          <motion.div initial={{ opacity:0,y:20 }} animate={{ opacity:1,y:0 }} style={{ background:'white', borderRadius:'24px', padding:'3rem', boxShadow:'var(--shadow-lg)', border:'2px solid #D1FAE5' }}>
            <div style={{ textAlign:'center', marginBottom:'2rem' }}>
              <FiCheckCircle style={{ fontSize:'3.5rem', color:'#10B981', marginBottom:'1rem' }} />
              <h2 style={{ fontFamily:'Fraunces,serif', color:'var(--navy)' }}>Certificate Verified ✓</h2>
              <p style={{ color:'var(--gray-400)', fontSize:'0.85rem' }}>Authentic Smart Quality Systems certificate</p>
            </div>
            <div style={{ background:'var(--off-white)', borderRadius:'14px', padding:'1.5rem' }}>
              {[['Certificate', cert.certificate_title],['Issued To', cert.client_name],['Company', cert.company_name],['Issue Date', new Date(cert.issue_date).toLocaleDateString('en-GB',{day:'numeric',month:'long',year:'numeric'})],['Expiry', cert.expiry_date ? new Date(cert.expiry_date).toLocaleDateString('en-GB',{day:'numeric',month:'long',year:'numeric'}) : 'No expiry'],['Serial', cert.serial_number],['Status', cert.status?.toUpperCase()]].filter(d=>d[1]).map(([label,val])=>(
                <div key={label} style={{ display:'flex', justifyContent:'space-between', padding:'0.7rem 0', borderBottom:'1px solid var(--gray-200)' }}>
                  <span style={{ fontWeight:600, color:'var(--gray-500)', fontSize:'0.85rem' }}>{label}</span>
                  <span style={{ color: label==='Status' && cert.status==='active' ? '#10B981' : label==='Status' && cert.status==='revoked' ? '#EF4444' : 'var(--navy)', fontWeight:500, fontSize:'0.9rem' }}>{val}</span>
                </div>
              ))}
            </div>
          </motion.div>
        )}
      </div>
    </div>
  );
}
